import { Stripe, loadStripe } from "@stripe/stripe-js";

let stripePromise: Stripe | null;

const initializeStripe = async () => {
  if (!stripePromise) {
    // stripePromise = await loadStripe("pk_test_51KYAUiC391gsfoZ26VgZY1E1KMborbwrIspDOUk9PRr8nrQlb1PUANG5MsGkU4dOR4TfO03dgYLo6o2tw1Wz71Aa00YYH0MMYr");
    stripePromise = await loadStripe(process.env.REACT_APP_NODE_ENV === "DEV" ? process.env.REACT_APP_STRIPE_TEST_KEY : process.env.REACT_APP_STRIPE_KEY);
  }
  return stripePromise;
};
export default initializeStripe;
